import { DecodedToken } from 'app/types';
import jwtDecode from 'jwt-decode';

export const auth = {
  setToken(token: string, remember): void {
    if (remember) {
      localStorage.setItem('user_token', token);
    } else {
      sessionStorage.setItem('user_token', token);
    }
  },
  setRefreshToken(token: string): void {
    localStorage.setItem('refresh_token', token);
  },
  getToken(): string | null {
    let token: string | null = '';
    if (localStorage.getItem('user_token')) {
      token = localStorage.getItem('user_token');
    } else if (sessionStorage.getItem('user_token')) {
      token = sessionStorage.getItem('user_token');
    }
    if (token) {
      return token;
    } else {
      this.logout();
      return null;
    }
  },
  getRefreshToken(): string | null {
    let token: string | null = '';
    token = localStorage.getItem('refresh_token');
    if (token) {
      return token;
    } else {
      // this.logout();
      return null;
    }
  },
  logout() {
    window.localStorage.setItem('CREDENTIALS_FLUSH', Date.now().toString());
    window.localStorage.removeItem('CREDENTIALS_FLUSH');
    localStorage.removeItem('user_token');
    sessionStorage.removeItem('user_token');
    localStorage.removeItem('refresh_token');
  },
  getUserData(): DecodedToken {
    const token = this.getToken();
    if (token) {
      try {
        return jwtDecode(token ? token : '');
      } catch {
        return {};
      }
    }
    return {};
  },
};
